import React from 'react'
import { buildLayoutConfig, COMMON_LAYOUT_EDITABLE_FIELDS, IntroStatsPanel, LayoutSections } from './layoutShared'

const DEFAULT_CONFIG = {
  heroBackgroundColor: '#eef4ff',
  heroTextColor: '#0f172a',
  heroSubtitleColor: '#334155',
  formBorderColor: '#2563eb',
  formBorderWidth: 3,
  ctaBandBackgroundColor: '#dbeafe',
}

function BasicTemplate4Layout({
  mode = 'public',
  heroTitle,
  heroSubtitle,
  heroImageFileId,
  sections = [],
  formEnabled = true,
  introStats = [],
  customConfig = {},
  resolveAssetUrl,
  formCard = null,
  recommendedProductsCard = null,
  previewBanner = null,
  surveyModal = null,
  surveyDoneModal = null,
}) {
  const config = buildLayoutConfig('basic-template-4', customConfig, DEFAULT_CONFIG)
  const isLive = mode === 'live'
  return (
    <div className="min-h-full bg-white text-slate-900">
      {previewBanner}
      <div className="px-4 pt-18 pb-12 md:pt-22 md:pb-14" style={{ backgroundColor: config.heroBackgroundColor }}>
        <div className={`mx-auto text-center ${isLive ? 'max-w-full' : 'max-w-5xl'}`}>
          {heroTitle && <h1 className="whitespace-pre-line text-5xl md:text-6xl font-extrabold tracking-tight leading-tight" style={{ color: config.heroTextColor }}>{heroTitle}</h1>}
          {heroSubtitle && <p className="mt-5 text-xl md:text-2xl leading-8 whitespace-pre-line" style={{ color: config.heroSubtitleColor }}>{heroSubtitle}</p>}
          {heroImageFileId && (
            <div className="mt-10 overflow-hidden rounded-[32px] border border-white/70 bg-white shadow-xl">
              <img src={resolveAssetUrl(heroImageFileId)} alt="" className="w-full max-h-[420px] object-cover" />
            </div>
          )}
        </div>
      </div>

      {(formEnabled || recommendedProductsCard) && (
        <div className="border-y border-blue-100 px-4 py-8" style={{ backgroundColor: config.ctaBandBackgroundColor }}>
          <div className={`mx-auto ${isLive ? 'max-w-full space-y-3' : 'max-w-6xl grid grid-cols-1 xl:grid-cols-[minmax(0,1fr)_140px] gap-4 items-start'}`}>
            {formEnabled && formCard}
            {recommendedProductsCard}
          </div>
        </div>
      )}

      <div className="px-4 py-12 md:py-14">
        <div className={`mx-auto ${isLive ? 'max-w-full space-y-4' : 'max-w-5xl space-y-6'}`}>
          <IntroStatsPanel introStats={introStats} />
          <LayoutSections sections={sections} resolveAssetUrl={resolveAssetUrl} variant={isLive ? 'compact' : 'default'} />
        </div>
      </div>

      {surveyModal}
      {surveyDoneModal}
    </div>
  )
}

export const basicTemplate4StyleLayout = {
  key: 'basic-template-4',
  label: '기본 템플릿 4 - CTA 강조형',
  description: '상단 집중형 히어로와 별도 CTA 밴드를 사용하는 레이아웃입니다.',
  editableConfigFields: [
    ...COMMON_LAYOUT_EDITABLE_FIELDS,
    { key: 'ctaBandBackgroundColor', label: 'CTA 밴드 배경색', placeholder: '#dbeafe' },
  ],
  normalizeCustomConfig: (customConfig) => buildLayoutConfig('basic-template-4', customConfig, DEFAULT_CONFIG),
  Component: BasicTemplate4Layout,
}
